/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import ClChart from './chart/cl.chart'
import ClEvent from './event/cl.event'
import ClDatas, {
    STOCK_TYPE_IDX,
    STOCK_TYPE_STK,
    STOCK_TRADETIME,
    FIELD_TRADETIME,
    getValue
} from './datas/cl.data.js'

import ClFormula from './datas/cl.formula.js'

import * as ChartRes from './cl.chart.res.js'
import * as Utils from './cl.utils'

import ClDrawKBar from './chart/cl.draw.kbar'
import ClDrawZLine from './chart/cl.draw.zline.js'
import ClDrawMark from './chart/cl.draw.mark.js'
import ClDrawVBar from './chart/cl.draw.vbar'
import ClDrawVLine from './chart/cl.draw.vline.js'
import ClDrawHbar from './chart/cl.draw.hbar.js'


import {
    getLineColor,
    _initChartInfo
} from './chart/cl.chart.init.js'

//////////////////////////////////////
/** @module CLAPI */
//////////////////////////////////////
// 进入这里后每个图表仅仅处理固定的数据格式
// 外部必须将数据转换为固定格式后传入
// 统一输出仅仅 ClChart 对象


function getData(source, field, index) {
    return getValue({
        fields: source.fields,
        value: source.datas
    }, field, index)
}

class singleChart {
    constructor(chartInfo, event, chartname, savelinkInfo) {
        this.chartname = chartname
        this.chart = new ClChart(chartInfo)
        this.scale = window.devicePixelRatio
        chartInfo.scale = window.devicePixelRatio
        this.datas = new ClDatas()
        this.chart.initChart(this.datas, event, savelinkInfo)
        this.setTradeTimes(STOCK_TRADETIME)
        // 设置浮动窗口
        this.fwindow = {
            winName: '',
            winRect : {},
            winWorks: {}
        }
    }
    clear() {
        this.chart.clear()
        if (typeof this.dataLayer !== 'undefined') {
            this.chart.dataLayer.clearData()
        }
    }
    // 设置交易时间
    setTradeTimes(value) {
        this.chart.setData('TRADETIME', FIELD_TRADETIME, value)
        this.chart.dataLayer.tradeTime = value;
    }
    setTradeDate(value) {
        this.chart.dataLayer.tradeDate = value
    }
    setLastDate(value) {
        this.chart.dataLayer.lastDate = value
    }
    setKeyWord(curkey, curinfo) {
        this.chart.dataLayer.linkInfo.curKey = curkey;
        if (this.chart.dataLayer.linkInfo.static === undefined) {
            this.chart.dataLayer.linkInfo.static = curinfo;
        }
        else {
            // console.log(this.chart.dataLayer.linkInfo.static, curinfo);          
            Utils.mergeJsonOfDeep(this.chart.dataLayer.linkInfo.static, curinfo)   
        }
    }    
    setKeyInfo(value) {
        this.chart.dataLayer.keyInfo = value
    }
    getKeyInfo(curkey) {
        if (curkey === undefined) {
            return this.chart.dataLayer.keyInfo
        }
        else {
            return this.chart.dataLayer.keyInfo[curkey]
        }
    }
    // 得到一个新的一位数组 index = -1 表示遍历所有数据
    getOneDatas(datas, nfield, index) {
        let out = []
        if (index === -1) {
            for (let ii = 0; ii < datas.value.length; ii++) {
                out.push(getValue(datas, nfield, ii))
            }
        } else {
            out.push(getValue(datas, nfield, ii))
        }
        return out
    }
    findData(key) {
        return this.chart.findData(key)
    }
    // 设置其他数据源
    setData(key, indata) {
        // console.log(key, indata);
        this.chart.setData(key, indata.fields, indata.datas)
    }
    setAxisXinfo(dataTxt, showTxt) {
        // dataTxt 为正常显示的信息
        // showTxt 为特殊显示的信息 按块定位
        this.chart.dataLayer.axisXinfo.dataTxt = dataTxt
        this.chart.dataLayer.axisXinfo.showTxt = []
        if (showTxt !== undefined) {
            this.chart.dataLayer.axisXinfo.showTxt = showTxt
        }
        // this.chart.dataLayer.linkInfo.showMode = 'init'
        this.chart.dataLayer.linkInfo.minIndex = 0
        this.chart.dataLayer.linkInfo.maxIndex = dataTxt.length - 1
        // console.log(this.chart.dataLayer.axisXinfo)
    }
    bindData(chart, key) {
        this.chart.bindData(chart, key)
    }
    createChartIndex(className, usercfg, callback) {
        const curName = this.chartname + '.' + Object.keys(this.chart.childCharts).length
        return this.chart.createChart(curName, className, usercfg, callback)
    }
    createChart(curName, className, usercfg, callback) {
        return this.chart.createChart(curName, className, usercfg, callback)
    }
    destroyChart(curName) {
        this.chart.destroyChart(curName)
    }
    // initLinkInfo(cname) {

    // }
    setlinkInfo(key, value) {
        this.chart.dataLayer.linkInfo[key] = value
    }
    onPaint(chart) {
        this.chart.onPaint(chart)
    }
    // 以下为浮动窗口定义
    getFwindow(winName) {
        if (this.fwindow.winName === '' || winName === undefined) {
            return 0;
        }
        if (this.fwindow.winName !== winName) {
            return 0
        }
        return 1
    }
    initFwindow(winName, frect) {
        if (this.fwindow.winName !== '') {
            if (this.fwindow.winName !== winName || 
                frect.left !== this.fwindow.winRect.left || 
                frect.top !== this.fwindow.winRect.top) {
                this.stopFwindow()
            }
        }
        this.fwindow.winName = winName
        this.fwindow.winRect.left = frect.left
        this.fwindow.winRect.top = frect.top
        this.fwindow.winRect.width = frect.width
        this.fwindow.winRect.height = frect.height
        this.fwindow.winWorks = {}
    }
    openFwindow(workName, className, usercfg, callback) {
        if (this.fwindow.winWorks[workName] === undefined) {
            this.fwindow.winWorks[workName] = this.createChart(workName, className, usercfg, callback)
        }
        return this.fwindow.winWorks[workName]
    }
    setFwindow(workName, indata) {
        if (this.fwindow.winName === '') {
            return
        }
        const worker = this.fwindow.winWorks[workName]
        if (worker === undefined) {
            return
        }
        if (indata !== undefined) {
            this.setData(workName, indata)
            this.bindData(worker, workName)
        }
        worker.onPaint()
    }
    stopFwindow() {
        if (this.fwindow.winName !== '') {
            Object.values(this.fwindow.winWorks).forEach(worker => {
                worker.onClear()
            });
            Object.keys(this.fwindow.winWorks).forEach(wname => {
                this.destroyChart(wname)
            });
        }
        this.fwindow.winRect = {}
        this.fwindow.winWorks = {}
        this.fwindow.winName = ''
    }
}
class manageChart {
    constructor(cfg) {
        this.chartInfo = _initChartInfo(cfg)
        this.event = new ClEvent(this.chartInfo)
        // 这里保存所有linkinfo信息
        this.saveLinkInfo = {}
        this.shareKeyInfo = {}
        // 这里开始初始化
        this.chartList = []

    }
    getChartIndex(cindex) {
        if (cindex < this.chartList.length && cindex >= 0) {
            return this.chartList[cindex]
        }
        return this.chartList[0]
    }

    getChart(cname) {
        for (let ii = 0; ii < this.chartList.length; ii++) {
            if (this.chartList[ii].chartname === cname) {
                return this.chartList[ii]
            }
        }
        return null
    }
    getUserChart(cname, uname) {
        const curchart = this.getChart(cname)
        // console.log(curchart, cname);
        if (!curchart) {
            return null
        }
        return curchart.chart.getChart(uname)
    }
    clearChart() {
        for (let ii = 0; ii < this.chartList.length; ii++) {
            this.chartList[ii].clear()
            this.chartList[ii].destroyChart(this.chartList[ii].chartname)
        }
        this.chartList = []
    }
    initChart(cnames) {
        if (cnames.length < 1) {
            return
        }
        // 保存老的配置
        for (let ii = 0; ii < this.chartList.length; ii++) {
            this.saveLinkInfo[this.chartList[ii].chartname] = Utils.copyJsonOfDeep(this.chartList[ii].chart.dataLayer.linkInfo)
            this.chartList[ii].clear()
            this.chartList[ii] = null
        }
        // 清理以前的窗口
        this.chartList = []
        for (let ii = 0; ii < cnames.length; ii++) {
            this.chartList.push(new singleChart(this.chartInfo, this.event, cnames[ii], this.saveLinkInfo[cnames[ii]]))
        }
        this.event.setCharts(this.chartList)
        return this.chartList[0]
    }
    onPaint(sonChart) {
        for (let ii = 0; ii < this.chartList.length; ii++) {
            this.chartList[ii].onPaint(sonChart)
        }
    }
}

// 'average'
// 'splitly'
// 'sidebar'
// const CH1 = 0.618
// const CH2 = 0.382 * 0.382
// const CH3 = 0.618 * 0.382
// 得到默认的 height width
export function getChartRect(region, cols, rows, colidx, rowidx) {
    // console.log(region);
    const scale = window.devicePixelRatio
    let top = region.top
    let left = region.left
    let height = region.height
    let width = region.width

    if (region.style === 'average') {
        let ww = (width) / cols
        let hh = (height) / rows
        top += rowidx * hh
        left += colidx * ww
        return {
            top,
            left,
            width: ww,
            height: hh,
        }
    } else if (region.style === 'splitly') {
        let fixed = width * 0.382 * 0.618
        if (region.rwidth !== undefined) {
            fixed = region.rwidth
        }
        if (cols > 1) {

            if (colidx > 0) {
                left += width - fixed - scale
                width = fixed
            } else {
                width = width - fixed - scale
            }
        }
        
        if (rows > 1) {
            if (rowidx > 0) {
                const h0 = rows < 4 ? height * 0.618 : height * 0.5
                top += h0
                const sumH = height - h0
                if (rows > 3) {
                    const axisH = scale * 15
                    height = (sumH - axisH) / (rows - 1)
                    top += height * (rowidx - 1)
                    if (rows - 1 == rowidx) {
                        height += axisH
                    }
                } else if (rows == 3) {
                    if (rowidx === 1) {
                        height = sumH * 0.382
                    } else { // if (rowidx === 2) 
                        top += sumH * 0.382
                        height = sumH * 0.618
                    }
                } else if (rows == 2) {
                    height = sumH
                }
            } else {
                height = rows < 4 ? height * 0.618 : height * 0.5
            }
            // console.log(rowidx, top, height, left);
        }
        return {
            top,
            left,
            width,
            height
        }
    }
    // region.style === 'sidebar'
    return {
        top,
        left,
        width,
        height
    }
}

export const CLAPI = {
    ClChart,
    ClEvent,
    ClDatas,
    ClFormula,
    ChartRes,
    Utils,
    STOCK_TYPE_IDX,
    STOCK_TYPE_STK,
    STOCK_TRADETIME,
    getData,
    getLineColor,
    manageChart,
    getChartRect,
    ClDrawKBar,
    ClDrawZLine,
    ClDrawMark,
    ClDrawVBar,
    ClDrawVLine,
    ClDrawHbar,
}